import React, {
  memo,
  ReactEventHandler,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { Button } from "react-bootstrap";
import { useOnClickOutside } from "usehooks-ts";

import { useEditorPopupContext } from "../../../contexts/editorPopupsContext";
import { CustomInput } from "../../CustomInput/CustomInput";
import { LinkUtils } from "./utils";

export interface IProps {
  onCancel: () => void;
  editor: any;
}

const PrepareLinkComponent: React.FC<IProps> = memo(({ onCancel, editor }) => {
  const [value, setValue] = useState("");
  const { url } = useEditorPopupContext();

  const ref = useRef(null);

  useEffect(() => {
    if (url) {
      setValue(url || "");
    }
  }, [url, editor]);

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  }, []);

  useOnClickOutside(ref, () => {
    LinkUtils.removeMark(editor);
    onCancel();
  });

  const cancel = () => {
    LinkUtils.removeMark(editor);
    onCancel();
  };

  const save = () => {
    LinkUtils.removeMark(editor);
    if (url) {
      LinkUtils.editLink(editor, value);
      onCancel();
      return;
    }
    setTimeout(() => {
      LinkUtils.createLink(editor, value);
      onCancel();
    });
  };

  const handleBlur = () => {
    LinkUtils.removeMark(editor);
    onCancel();
  };

  const handleInputBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    e.stopPropagation();
  };

  return (
    <div
      onBlur={handleBlur}
      tabIndex={-1}
      ref={ref}
      className="link-prepare__form"
    >
      <CustomInput
        label="URL"
        placeholder="Enter URL"
        type="text"
        handleChange={handleChange}
        inputValue={value}
        autoFocus
        onBlur={handleInputBlur}
      />
      <div className="link-prepare__button-container">
        <Button
          className="btn btn-sm"
          size="sm"
          variant="secondary"
          onClick={cancel}
        >
          Cancel
        </Button>
        <Button
          size="sm"
          className="btn btn-primary"
          onClick={save}
          disabled={!value}
        >
          Save
        </Button>
      </div>
    </div>
  );
});

export { PrepareLinkComponent };
